// 관성 스크롤(Lenis)과 스크롤 이동 도우미.
// - PC 마우스 환경(761px 이상)에서만 켠다. 휴대폰·터치·'동작 줄이기'에서는 브라우저 기본 스크롤.
// - 사이트 안의 스크롤 이동은 scrollToTarget() 으로 하면 Lenis 가 켜져 있든 아니든 같은 결과가 나온다.

let lenis = null;
let rafId = 0;
let loading = null;

export const reducedMotion = () =>
  typeof window !== "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const wantsSmooth = () =>
  !reducedMotion() && !!window.matchMedia && window.matchMedia("(pointer: fine) and (min-width: 761px)").matches;

export function startSmoothScroll() {
  if (lenis || loading || !wantsSmooth()) return;
  loading = import("lenis")
    .then(({ default: Lenis }) => {
      loading = null;
      if (lenis || !wantsSmooth()) return;
      lenis = new Lenis({ lerp: 0.1, wheelMultiplier: 1 });
      const raf = (t) => {
        if (!lenis) return;
        lenis.raf(t);
        rafId = requestAnimationFrame(raf);
      };
      rafId = requestAnimationFrame(raf);
    })
    .catch(() => {
      loading = null; // 불러오지 못하면 기본 스크롤로 둔다
    });
}

export function stopSmoothScroll() {
  cancelAnimationFrame(rafId);
  if (lenis) lenis.destroy();
  lenis = null;
}

// 사진 확대보기·모바일 메뉴처럼 뒤 화면 스크롤을 막을 때
export function pauseSmoothScroll(paused) {
  if (!lenis) return;
  if (paused) lenis.stop();
  else lenis.start();
}

// target: 요소 또는 숫자(px). immediate: 즉시 이동(페이지 이동 직후 등)
// 요소로 이동할 때는 각 페이지 CSS 의 scroll-padding-top(헤더·보조 메뉴 높이)만큼 띄운다.
export function scrollToTarget(target, { immediate = false } = {}) {
  const isEl = typeof target !== "number";
  if (lenis) {
    lenis.resize(); // 페이지가 바뀐 직후에도 새 페이지 높이 기준으로 이동하도록(이전 페이지 높이로 잘리지 않게)
    const pad = isEl ? parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0 : 0;
    lenis.scrollTo(target, { offset: -pad, immediate, force: true });
    return;
  }
  const behavior = immediate ? "instant" : reducedMotion() ? "instant" : "smooth";
  if (isEl) target.scrollIntoView({ behavior, block: "start" });
  else window.scrollTo({ top: target, behavior });
}
